import React from 'react';

export default function SoccerBall() {
	// 5
	let style = {
		st0: {
 			fill:"#FFFFFF"
		},
		st46: {
 			fill:"#444444"
		}
	};
	return (
		<g>
			<path style={style.st0} d="M247,368.0300293c0,5.2299805-0.9599609,10.2399902-2.6999512,14.8599854
				c-2.7900391,7.3599854-7.5800781,13.7399902-13.7099609,18.4599609c-7.0900879,5.4700928-15.9699707,8.710083-25.6201172,8.710083
				c-23.2099609,0-42.0300293-18.8200684-42.0300293-42.0300293c0-4.8800049,0.8300781-9.5700684,2.3701172-13.9300537
				c2.6699219-7.6300049,7.4899902-14.25,13.7299805-19.1600342C186.1899414,329.3400879,195.1799316,326,204.9699707,326
				C228.1799316,326,247,344.8200684,247,368.0300293z"/>
			<path style={style.st46} d="M187.6098633,345.4000244l-4.2897949,10.4300537
				c-0.5800781,1.4099121-1.9899902,2.2799072-3.5100098,2.1699219l-11.2700195-0.8499756
				c-1.5100098-0.1199951-2.7800293-1.2000732-3.1401367-2.6700439l-0.0898438-0.3800049
				c2.6699219-7.6300049,7.4899902-14.25,13.7299805-19.1600342l7.6000977,6.4500732
				C187.8000488,342.3699951,188.1899414,343.9899902,187.6098633,345.4000244z"/>
			<path style={style.st46} d="M211.1881714,359.0812073l-1.4020996-11.1932678
				c-0.1891174-1.5097351,0.6160126-2.9693909,1.9938812-3.6148071l10.2270355-4.7904663
				c1.3758545-0.6444702,3.0101318-0.3305664,4.0493469,0.7777405l7.7227783,8.2363281
				c1.0408478,1.1100769,1.2478638,2.7643433,0.5126495,4.0966797l-5.4518738,9.8796387
				c-0.7345276,1.3311157-2.2425079,2.0379944-3.7355042,1.7510681l-11.0958405-2.1322632
				C212.5156403,361.8049622,211.377121,360.5896301,211.1881714,359.0812073z"/>
			<path style={style.st46} d="M244.3000488,382.8900146c-2.7900391,7.3599854-7.5800781,13.7399902-13.7099609,18.4599609
				l-4.6999512-7.1600342c-0.8300781-1.2700195-0.75-2.9399414,0.1999512-4.119873l7.079834-8.8000488
				c0.9501953-1.1899414,2.5500488-1.6300049,3.9799805-1.0900879L244.3000488,382.8900146z"/>
			<path style={style.st46} d="M204.7424927,390.5474243l-9.8085327,5.572052
				c-1.3229675,0.7515564-2.9795074,0.5651245-4.102356-0.4616394l-8.3342285-7.6211243
				c-1.1212158-1.0252686-1.4555054-2.6554871-0.8282776-4.0392761l4.6611481-10.2835999
				c0.6282043-1.3859863,2.0779266-2.2093201,3.5900421-2.0388794l11.213089,1.2638855
				c1.5107422,0.1702881,2.7401276,1.2938232,3.0453644,2.7831726l2.2685394,11.0687866
				C206.7525024,388.2800598,206.0643158,389.7965393,204.7424927,390.5474243z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/SoccerBall.js